import React from 'react'

import cls from './ourteam.module.scss'
import portrait1 from '@/shared/assets/portraits/portrait1.webp'
import portrait4 from '@/shared/assets/portraits/portrait2.webp'
import portrait3 from '@/shared/assets/portraits/portrait3.webp'
import portrait2 from '@/shared/assets/portraits/portrait4.webp'
import portrait5 from '@/shared/assets/portraits/portrait5.webp'
import portrait6 from '@/shared/assets/portraits/portrait6.webp'
import Marquee from 'react-fast-marquee'
import useResize from '@/shared/lib/hooks/useResize'
import { useTranslation } from 'react-i18next'

export const OurTeam = () => {
    const { t } = useTranslation()
    const data = [
        {
            name: 'Demitracis\nPapademitriou',
            role: t('aboutPage.ceo'),
            image: portrait1,
        },
        {
            name: 'Stefanos\nMarkopoulos',
            role: t('aboutPage.cpo'),
            image: portrait2,
        },
        {
            name: 'Bojan\nLukic',
            role: t('aboutPage.designer'),
            image: portrait3,
        },
        {
            name: 'Sergey\nAstakhov',
            role: t('aboutPage.frontend'),
            image: portrait4,
        },
        {
            name: 'Konstantin\nVukadinov',
            role: t('aboutPage.backend'),
            image: portrait5,
        },
        {
            name: 'Zoran\nVidovic',
            role: t('aboutPage.rfrontend'),
            image: portrait6,
        },
    ]

    const windowWidth = useResize()

    const teamRender = () => {
        if (windowWidth <= 1024) {
            return (
                <Marquee
                    speed={100}
                    className={cls.teamMarquee}
                >
                    <div className={cls.teammateContainer}>
                        {data.map((item) => (
                            <div className={cls.teammate}>
                                <img
                                    src={item.image}
                                    alt={item.name}
                                />
                                <h4>{item.name}</h4>
                                <p>{item.role}</p>
                            </div>
                        ))}
                    </div>
                </Marquee>
            )
        } else {
            return (
                <div className={cls.teammateContainer}>
                    {data.map((item) => (
                        <div className={cls.teammate}>
                            <img
                                src={item.image}
                                alt={item.name}
                                loading="lazy"
                            />
                            <h4>{item.name}</h4>
                            <p>{item.role}</p>
                        </div>
                    ))}
                </div>
            )
        }
    }
    return (
        <div className={cls.OurTeam}>
            <h2>{t('aboutPage.ourTeam')}</h2>
            {teamRender()}
        </div>
    )
}
